import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Sentry from '@sentry/react';
import InviteComponent from '../../common/InviteComponent';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ROUTE_DASHBOARD } from '../../navigation/constants';
import { get, parseClientError, post } from '../../../src/api/utils';
import { PARTNER_GET_BY_SIGNATURE } from '../../../src/api/constants';
import { roleSwitchRequested } from '../../screens/auth/actions.js';

function InviteScreen({ history }) {
    const [data, setData] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [isAccepted, setAccepted] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    // scroll top top
    useEffect(() => {
        localStorage.removeItem('invite');
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        setLoading(true);
        const id = history.location.pathname.split('/').pop();
        get(PARTNER_GET_BY_SIGNATURE(id))
            .then((respo) => {
                if (respo.data.data.status !== 'ACCEPTED') {
                    if (!respo.data.data.isValid)
                        setError(
                            'That invitation is no longer valid.  Please contact your Organization admin to request another one.',
                        );
                    setData(respo.data.data);
                } else {
                    setError(
                        'That invitation has already been accepted.  Please contact your Organization admin to request another one.',
                    );
                    setData({});
                }
                setLoading(false);
            })
            .catch((err) => {
                Sentry.captureException(err);
                setError(err.message);
                setLoading(false);
            });
    }, []);

    const onAcceptInvite = () => {
        setLoading(true);
        const id = history.location.pathname.split('/').pop();
        post(PARTNER_GET_BY_SIGNATURE(id))
            .then((response) => {
                setRoleId(
                    response.data.data.roleId || response.data.data[0].roleId,
                );
                setLoading(false);
                setAccepted(true);
            })
            .catch((err) => {
                Sentry.captureException(err);
                const error = parseClientError(err);
                setError(error.message);
                setData({});
                setLoading(false);
            });
    };
    const onLater = () => {
        history.push({ pathname: ROUTE_DASHBOARD });
    };

    const onContinue = () => {
        dispatch(roleSwitchRequested(roleId));
    };

    const buttonText = 'Join';

    return (
        <InviteComponent
            noData={data && data.id ? false : true}
            buttonText={buttonText}
            companyName={data && data.partner && data.partner.name}
            invitee={data && data.sender && data.sender.fullName}
            title={data && data.roleType && data.roleType.name}
            isLoading={isLoading}
            onClick={onAcceptInvite}
            onLater={onLater}
            onContinue={onContinue}
            isAccepted={isAccepted}
            error={error}
        />
    );
}

InviteScreen.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        location: PropTypes.object,
    }),
};

export default withRouter(InviteScreen);
